var _defs, _path, _path2, _rect, _rect2, _rect3, _rect4, _path3, _rect5, _path4, _polygon, _path5, _path6, _path7, _rect6, _rect7, _rect8, _rect9, _path8, _rect0, _path9, _polygon2, _path0, _path1, _path10, _rect1, _rect10, _rect11, _rect12, _path11, _rect13, _path12, _polygon3, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsFuture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "future",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 87.26 33.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons_future") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.35,34.58h-.51V29.9a.63.63,0,0,0-.52-.62,50.14,50.14,0,0,0-17.28,0,.63.63,0,0,0-.52.62v4.68H12V35h.52v4.73A3.23,3.23,0,0,0,9.3,42.9v1.57c0,1.78,1,1.93,1,1.93v3.05a1.8,1.8,0,0,0,1.8,1.81h.23a1.8,1.8,0,0,0,1.8-1.81V47.69H29.22v1.76A1.8,1.8,0,0,0,31,51.26h.23a1.8,1.8,0,0,0,1.8-1.81V46.24s1,0,1-1.77V42.9a3.22,3.22,0,0,0-3.22-3.22V35h.51Zm-20,10.64a1.12,1.12,0,1,1,1.12,1.12A1.12,1.12,0,0,1,11.4,45.22Zm15.94,1.63H16L15.35,46H28Zm1.54-1.63H14.49V38.54L13.16,35V30.64a57.93,57.93,0,0,1,17,0V35l-1.32,3.59Zm2-1.12a1.12,1.12,0,1,1-1.12,1.12A1.12,1.12,0,0,1,30.84,44.1Z",
    transform: "translate(-8.81 -18.06)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.43,38.41,30.2,35a138.4,138.4,0,0,0-17,0l1.77,3.46Z",
    transform: "translate(-8.81 -18.06)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.51,
    y: 21.62,
    width: 12.71,
    height: 0.59
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.51,
    y: 22.88,
    width: 12.71,
    height: 0.59
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.51,
    y: 24.14,
    width: 12.71,
    height: 0.59
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.51,
    y: 25.4,
    width: 12.71,
    height: 0.59
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.81,32.22H9.15a.35.35,0,0,0-.33.43l.49,2a.33.33,0,0,0,.33.26h1.44v-.37h.56l-.5-2.09A.34.34,0,0,0,10.81,32.22Z",
    transform: "translate(-8.81 -18.06)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.03,
    y: 16.52,
    width: 1.69,
    height: 0.37
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.72,35a.33.33,0,0,0,.33-.26l.49-2a.35.35,0,0,0-.33-.43H32.55a.35.35,0,0,0-.33.27l-.5,2.09h.56V35Z",
    transform: "translate(-8.81 -18.06)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "22.02 16.89 23.75 16.89 23.84 16.52 22.02 16.52 22.02 16.89"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.93,29.69V18.06H31.6V29.69l-.68-.1c-.06,0-6.26-.89-9.27-.89a86,86,0,0,0-9,.89Zm9.72-2.19a82,82,0,0,1,8.75.81v-9H13.13v9A79,79,0,0,1,21.65,27.5Z",
    transform: "translate(-8.81 -18.06)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.11,34.58H61.6V29.9a.63.63,0,0,0-.52-.62,50.14,50.14,0,0,0-17.28,0,.63.63,0,0,0-.52.62v4.68h-.52V35h.52v4.73a3.23,3.23,0,0,0-3.22,3.22v1.57c0,1.78,1,1.93,1,1.93v3.05a1.8,1.8,0,0,0,1.8,1.81h.23a1.8,1.8,0,0,0,1.8-1.81V47.69H60v1.76a1.81,1.81,0,0,0,1.8,1.81H62a1.81,1.81,0,0,0,1.81-1.81V46.24s1,0,1-1.77V42.9a3.22,3.22,0,0,0-3.22-3.22V35h.51Zm-20,10.64a1.12,1.12,0,1,1,1.12,1.12A1.12,1.12,0,0,1,42.16,45.22ZM58.1,46.85H46.78L46.11,46H58.77Zm1.54-1.63H45.25V38.54L43.92,35V30.64a57.93,57.93,0,0,1,17,0V35l-1.32,3.59Zm2-1.12a1.12,1.12,0,1,1-1.12,1.12A1.12,1.12,0,0,1,61.6,44.1Z",
    transform: "translate(-8.81 -18.06)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.19,38.41,61,35a138.4,138.4,0,0,0-17,0l1.77,3.46Z",
    transform: "translate(-8.81 -18.06)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 37.27,
    y: 21.62,
    width: 12.71,
    height: 0.59
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 37.27,
    y: 22.88,
    width: 12.71,
    height: 0.59
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 37.27,
    y: 24.14,
    width: 12.71,
    height: 0.59
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 37.27,
    y: 25.4,
    width: 12.71,
    height: 0.59
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.57,32.22H39.92a.35.35,0,0,0-.34.43l.49,2a.34.34,0,0,0,.33.26h1.44v-.37h.56l-.5-2.09A.34.34,0,0,0,41.57,32.22Z",
    transform: "translate(-8.81 -18.06)"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.79,
    y: 16.52,
    width: 1.69,
    height: 0.37
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.48,35a.33.33,0,0,0,.33-.26l.49-2a.35.35,0,0,0-.33-.43H63.31a.35.35,0,0,0-.33.27l-.5,2.09H63V35Z",
    transform: "translate(-8.81 -18.06)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "52.78 16.89 54.51 16.89 54.6 16.52 52.78 16.52 52.78 16.89"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.69,29.69V18.06H62.37V29.69l-.69-.1c-.06,0-6.26-.89-9.27-.89a86,86,0,0,0-9,.89Zm9.72-2.19a82.47,82.47,0,0,1,8.76.81v-9H43.89v9A79,79,0,0,1,52.41,27.5Z",
    transform: "translate(-8.81 -18.06)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.87,34.58h-.51V29.9a.63.63,0,0,0-.52-.62,50.14,50.14,0,0,0-17.28,0,.62.62,0,0,0-.51.62v4.68h-.53V35h.53v4.73a3.23,3.23,0,0,0-3.23,3.22v1.57c0,1.78,1,1.93,1,1.93v3.05a1.8,1.8,0,0,0,1.8,1.81h.23a1.8,1.8,0,0,0,1.8-1.81V47.69H90.74v1.76a1.81,1.81,0,0,0,1.8,1.81h.23a1.81,1.81,0,0,0,1.81-1.81V46.24s1,0,1-1.77V42.9a3.22,3.22,0,0,0-3.22-3.22V35h.51ZM72.93,45.22a1.12,1.12,0,1,1,1.12,1.12A1.12,1.12,0,0,1,72.93,45.22Zm15.93,1.63H77.54L76.87,46H89.53Zm1.54-1.63H76V38.54L74.68,35V30.64a57.93,57.93,0,0,1,17,0V35L90.4,38.54Zm2-1.12a1.12,1.12,0,1,1-1.12,1.12A1.12,1.12,0,0,1,92.36,44.1Z",
    transform: "translate(-8.81 -18.06)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90,38.41,91.72,35a138.4,138.4,0,0,0-17,0l1.77,3.46Z",
    transform: "translate(-8.81 -18.06)"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68.03,
    y: 21.62,
    width: 12.71,
    height: 0.59
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68.03,
    y: 22.88,
    width: 12.71,
    height: 0.59
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68.03,
    y: 24.14,
    width: 12.71,
    height: 0.59
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68.03,
    y: 25.4,
    width: 12.71,
    height: 0.59
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.33,32.22H70.68a.35.35,0,0,0-.34.43l.49,2a.34.34,0,0,0,.33.26H72.6v-.37h.56l-.5-2.09A.34.34,0,0,0,72.33,32.22Z",
    transform: "translate(-8.81 -18.06)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 63.55,
    y: 16.52,
    width: 1.69,
    height: 0.37
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.24,35a.33.33,0,0,0,.33-.26l.49-2a.35.35,0,0,0-.33-.43H94.07a.35.35,0,0,0-.33.27l-.5,2.09h.56V35Z",
    transform: "translate(-8.81 -18.06)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "83.55 16.89 85.28 16.89 85.36 16.52 83.55 16.52 83.55 16.89"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.45,29.69V18.06H93.12V29.69l-.68-.1c-.06,0-6.26-.89-9.27-.89a86,86,0,0,0-9,.89Zm9.72-2.19a82,82,0,0,1,8.75.81v-9H74.65v9A79,79,0,0,1,83.17,27.5Z",
    transform: "translate(-8.81 -18.06)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFuture);
export default __webpack_public_path__ + "static/media/icons_future.aa1a6956.svg";
export { ForwardRef as ReactComponent };